import React, {
  useEffect,
  useRef,
  useState,
  DependencyList,
  useContext,
} from "react";
import PropTypes from "prop-types";
import Overlay from "../../Overlay/index.jsx";
import Button from "../../common/Button/index.jsx";
import { langComponent, PAGE_STATE } from "../../../constants/index.jsx";
import useBlogs from "../../../hooks/useBlogs.js";

import { ReactComponent as VerifySvg } from "../../../assets/admin/menu/verify.svg";
import { ReactComponent as ArrowLeftSvg } from "../../../assets/icons/arrow-left-filled.svg";

import { Form, Formik } from "formik";
import TextBox from "../../common/TextBox/index.jsx";
import ComboBox from "../../common/ComboBox/index.jsx";

import DatePicker from "../../common/DatePicker/index.jsx";

import { ReactComponent as TrashSvg } from "../../../assets/admin/icons/trash.svg";
import { ReactComponent as CloseSvg } from "../../../assets/admin/close.svg";
import { ReactComponent as GearSvg } from "../../../assets/icons/gear.svg";
import { ReactComponent as ClosePrimarySvg } from "../../../assets/icons/close-primary.svg";

import { ReactComponent as ImageSvg } from "../../../assets/icons/image-circle.svg";

import { ReactComponent as ImageFilledSvg } from "../../../assets/icons/image-circle-filled.svg";
import {
  ClassicEditor,
  Context,
  Code,
  Bold,
  Essentials,
  Italic,
  Paragraph,
  Heading,
  BlockQuote,
  Font,
  Link,
  List,
  Underline,
  Strikethrough,
  RemoveFormat,
  Alignment,
  Indent,
  IndentBlock,
  AutoImage,
  Image,
  Base64UploadAdapter,
  ImageInsert,
  ImageResize,
  ImageStyle,
  ImageToolbar,
  ImageCaption,
  PictureEditing,
  MediaEmbed,
  FullPage,
  Autoformat,
  AutoLink,
  SourceEditing,
  ContextWatchdog,
  GeneralHtmlSupport,
} from "ckeditor5";
import { CKEditor, CKEditorContext } from "@ckeditor/ckeditor5-react";

import "ckeditor5/ckeditor5.css";

import "rc-slider/assets/index.css";

import "react-image-crop/src/ReactCrop.scss";
import "react-quill/dist/quill.snow.css";
import TextArea from "../../common/TextArea/index.jsx";
import AppContext from "../../../AppContext.jsx";
import useScreenSize from "../../../hooks/useScreenSize.js";

import _ from "lodash";
import { Navigation } from "swiper/modules";
import useFAQs from "../../../hooks/useFAQ.js";

const TabNameGrid = ({
  isMobile,
  isMobileViewTab,
  handleMobileViewTab,
  handleSettingClick,
}) => (
  <div className="admin-bp-add-form-work-editor-tab-name-grid">
    {isMobileViewTab && (
      <div className="admin-bp-add-form-work-editor-action-grid">
        <div className="admin-bp-add-form-work-editor-action-grid-action">
          <ArrowLeftSvg onClick={handleMobileViewTab} />
        </div>
      </div>
    )}
    {isMobile && !isMobileViewTab && (
      <div
        className="admin-bp-add-form-work-editor-tab-name-grid"
        onClick={handleSettingClick}
      >
        <GearSvg />
      </div>
    )}
  </div>
);

const ActionGrid = ({
  isMobile,
  isMobileViewTab,
  onClose,
  handleMobileViewTab,
  handleSettingClick,
}) => (
  <div className="admin-bp-add-form__ctas">
    {!isMobileViewTab && (
      <div className={"admin-bp-add-form__ctas-action"}>
        <Button label="Publish" type="submit" />
        {isMobile && (
          <ClosePrimarySvg width={24} height={24} onClick={() => onClose()} />
        )}
      </div>
    )}
    {isMobile && isMobileViewTab && (
      <div className="admin-bp-add-form__ctas-action" style={{ flexGrow: 1 }}>
        <ArrowLeftSvg width={18} height={18} onClick={handleMobileViewTab} />
      </div>
    )}
    {isMobile && !isMobileViewTab && (
      <div className="admin-bp-add-form__ctas-action">
        <GearSvg width={24} height={24} onClick={() => handleSettingClick()} />
      </div>
    )}
  </div>
);

const SettingTab = ({
  TranslationCommon,
  FAQCategory,
  FAQSubCategory,
  isMobile,
  isMobileViewTab,
}) => (
  <div
    className={`admin-bp-add-form__settings ${
      isMobileViewTab ? "admin-bp-add-form__settings--mobile" : ""
    }`}
  >
    {(!isMobile || isMobileViewTab) && (
      <div className="admin-bp-add-form__settings__content">
        <div className="admin-bp-add-form__settings__content__cover-title">
          Settings
        </div>
        <ComboBox
          label={TranslationCommon("Category")}
          name="category"
          width="100%"
          options={FAQCategory}
          placeholder={TranslationCommon("Category")}
        />
        <ComboBox
          label={TranslationCommon("Sub Category")}
          name="subCategory"
          width="100%"
          options={FAQSubCategory}
          placeholder={TranslationCommon("Sub Category")}
        />
        <ComboBox
          label={TranslationCommon("Language")}
          name="language"
          width="100%"
          options={[
            { name: "English", value: "en" },
            { name: "Thai", value: "th" },
            { name: "Chinese", value: "cn" },
          ]}
          placeholder={TranslationCommon("Language")}
        />
      </div>
    )}
  </div>
);

const EditorBody = ({
  isMobile,
  isMobileViewTab,
  content,
  editorRef,
  handleChangeContent,
}) => (
  <div
    className={
      !isMobile || isMobileViewTab
        ? "admin-bp-add-form__editor"
        : "admin-bp-add-form__editor admin-bp-add-form__editor--mobile"
    }
    style={{ display: isMobileViewTab ? "none" : "flex" }}
  >
    <CKEditorContext context={Context} contextWatchdog={ContextWatchdog}>
      <CKEditor
        editor={ClassicEditor}
        config={{
          placeholder: "Type or paste your content here!",
          plugins: [
            Essentials,
            Font,
            Heading,
            Code,
            Bold,
            Italic,
            Paragraph,
            Underline,
            Strikethrough,
            BlockQuote,
            List,
            Indent,
            IndentBlock,
            Link,
            AutoImage,
            Image,
            ImageInsert,
            ImageResize,
            ImageStyle,
            ImageToolbar,
            ImageCaption,
            PictureEditing,
            MediaEmbed,
            FullPage,
            Alignment,
            RemoveFormat,
            Autoformat,
            AutoLink,
            Base64UploadAdapter,
            SourceEditing,
            GeneralHtmlSupport,
          ],
          toolbar: [
            "undo",
            "redo",
            "|",
            "heading",
            "fontSize",
            "fontColor",
            "fontBackgroundColor",
            "bold",
            "italic",
            "alignment",
            "underline",
            "strikethrough",
            "removeFormat",
            "blockQuote",
            "|",
            "bulletedList",
            "numberedList",
            "outdent",
            "indent",
            "|",
            "link",
            "insertImage",
            "mediaEmbed",
            "sourceEditing",
          ],
          fontSize: {
            options: [9, 11, 13, "default", 17, 19, 21, 24, 32, 38, 40],
          },
          image: {
            resizeOptions: [
              {
                name: "resizeImage:original",
                label: "Default image width",
                value: null,
              },
              {
                name: "resizeImage:50",
                label: "50% page width",
                value: "50",
              },
              {
                name: "resizeImage:75",
                label: "75% page width",
                value: "75",
              },
            ],
            toolbar: [
              "imageTextAlternative",
              "toggleImageCaption",
              "|",
              "imageStyle:inline",
              "imageStyle:wrapText",
              "imageStyle:breakText",
              "|",
              "resizeImage",
              "|",
              "editImage",
            ],
          },
          htmlSupport: {
            allow: [
              {
                name: /.*/,
                attributes: true,
                classes: true,
                styles: true,
              },
            ],
            disallow: [
              {
                attributes: [
                  { key: /^on(.*)/i, value: true },
                  {
                    key: /.*/,
                    value: /(\b)(on\S+)(\s*)=|javascript:|(<\s*)(\/*)script/i,
                  },
                  {
                    key: /.*/,
                    value: /data:(?!image\/(png|jpeg|gif|webp))/i,
                  },
                ],
              },
              { name: "script" },
            ],
          },
        }}
        data={content}
        onChange={handleChangeContent}
        onReady={(editor) => {
          editorRef.current = { editor };
        }}
      />
    </CKEditorContext>
  </div>
);

const FaqEditor = ({
  isMobile,
  isMobileViewTab,
  content,
  editorRef,
  handleChangeContent,
  TranslationCommon,
  FAQCategory,
  FAQSubCategory,
  handleChangeCategory,
  onClose,
  handleSettingClick,
  handleMobileViewTab,
}) => (
  <>
    <ActionGrid
      isMobile={isMobile}
      isMobileViewTab={isMobileViewTab}
      onClose={onClose}
      handleMobileViewTab={handleMobileViewTab}
      handleSettingClick={handleSettingClick}
    />
    <SettingTab
      TranslationCommon={TranslationCommon}
      FAQCategory={FAQCategory}
      FAQSubCategory={FAQSubCategory}
      handleChangeCategory={handleChangeCategory}
      isMobile={isMobile}
      isMobileViewTab={isMobileViewTab}
    />
    <EditorBody
      isMobile={isMobile}
      isMobileViewTab={isMobileViewTab}
      content={content}
      editorRef={editorRef}
      handleChangeContent={handleChangeContent}
    />
  </>
);

const ViewFaq = ({ editing: _editing, onClose, onSuccess }) => {
  const [editing, setEditing] = useState(_editing);
  const [pageState, setPageState] = useState(
    editing ? PAGE_STATE.LOADING : PAGE_STATE.IDLE
  );
  const [savingState, setSavingState] = useState(PAGE_STATE.IDLE);
  const [initialValues, setInitialValues] = useState({
    content: "",
    category: undefined,
    subCategory: undefined,
    language: undefined,
    status: 1,
  });
  const [tabs, setTabs] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(undefined);
  const [selectedSubCategory, setSelectedSubCategory] = useState(undefined);
  const [selectedTab, setSelectedTab] = useState("Setting");
  const [isMobile, setIsMobile] = useState(false);
  const [isMobileViewTab, setIsMobileViewTab] = useState(false);
  const [tags, setTags] = useState([]);

  const { screenSize } = useScreenSize();
  const formikRef = useRef(null);
  const editorRef = useRef("");

  const { getLang, faqs, lang } = useContext(AppContext);
  const TranslationCommon = getLang(langComponent.common);
  const FAQCategory = faqs.category;
  const FAQSubCategory = faqs.subCategory;

  const { getFAQ, createFAQ, patchFAQ } = useFAQs();

  useEffect(() => {
    const _tabs = ["Image", "Setting"];
    const isMobileView = !["lg", "xl"].includes(screenSize);
    setTabs(_tabs);
    setIsMobile(isMobileView);
    setSelectedTab(_tabs[1]);

    if (!isMobile) {
      setIsMobileViewTab(false);
    }
  }, [screenSize]);

  useEffect(() => {
    if (!editing) return;
    fetchData();
  }, [editing]);

  const fetchData = async () => {
    const { category, content, subCategory, effectiveDate, status, language } =
      await getFAQ(editing);

    setInitialValues({
      category,
      subCategory,
      content,
      effectiveDate,
      status,
      language,
    });
    setPageState(PAGE_STATE.IDLE);
  };

  const handleSettingClick = () => {
    setIsMobileViewTab(isMobile);
  };

  const handleMobileViewTab = () => {
    setIsMobileViewTab(false);
  };

  const handleChangeContent = () => {
    const editor = editorRef.current.editor;
    const currentData = editor.getData();
    setInitialValues({ ...initialValues, content: currentData });
  };

  const handleChangeCategory = (value) => {
    // console.log(value);
  };

  const handleSubmit = async (
    { content, category, subCategory, language },
    options
  ) => {
    setSavingState(PAGE_STATE.LOADING);
    const faqData = {
      content: initialValues.content,
      category: category,
      subCategory: subCategory,
      status: initialValues.status,
      language: language,
    };

    try {
      if (editing) {
        await patchFAQ(editing, faqData);
      } else {
        await createFAQ(faqData);
      }
      setSavingState(PAGE_STATE.IDLE);
      onSuccess();
    } catch (error) {
      console.error(error.message);
      setSavingState(PAGE_STATE.ERROR);
    }
  };

  if (pageState === PAGE_STATE.LOADING) {
    return <Overlay />;
  }

  return (
    <Overlay onClose={onClose} style={{ alignItems: "flex-start" }}>
      <div className="admin-bp-add">
        <div className="project-view-close" onClick={onClose}>
          <CloseSvg />
          {TranslationCommon("Close")}
        </div>
        <Formik
          innerRef={formikRef}
          initialValues={initialValues}
          onSubmit={handleSubmit}
        >
          <Form
            className={`admin-bp-add-form ${
              isMobile ? "admin-bp-add-form--mobile" : ""
            }`}
          >
            <FaqEditor
              isMobile={isMobile}
              isMobileViewTab={isMobileViewTab}
              content={initialValues.content}
              editorRef={editorRef}
              handleChangeContent={handleChangeContent}
              TranslationCommon={TranslationCommon}
              FAQCategory={FAQCategory}
              FAQSubCategory={FAQSubCategory}
              handleChangeCategory={handleChangeCategory}
              onClose={onClose}
              handleSettingClick={handleSettingClick}
              handleMobileViewTab={handleMobileViewTab}
            />
          </Form>
        </Formik>
      </div>
    </Overlay>
  );
};

ViewFaq.propTypes = {
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
  editing: PropTypes.string,
};

ViewFaq.defaultProps = {
  onClose: () => {},
  onSuccess: () => {},
  editing: undefined,
};

export default ViewFaq;
